import HighlightingRule, { randomColor } from "views/logic/views/formatting/highlighting/HighlightingRule";
import { selectActiveViewState, selectActiveQuery } from "views/logic/slices/viewSelectors";
import FormattingSettings from "views/logic/views/formatting/FormattingSettings";
import { updateViewState } from "views/logic/slices/viewSlice";
import { selectHighlightingRules } from "views/logic/slices/highlightSelectors";
export const updateHighlightingRules = (rules) => async (dispatch, getState) => {
  const activeQuery = selectActiveQuery(getState());
  const currentViewState = selectActiveViewState(getState());
  const { formatting = FormattingSettings.empty() } = currentViewState;
  const newViewState = currentViewState.toBuilder().formatting(formatting.toBuilder().highlighting(rules).build()).build();
  return dispatch(updateViewState(activeQuery, newViewState));
};
export const updateHighlightingRule = (rule, payload) => async (dispatch, getState) => {
  const highlightingRules = selectHighlightingRules(getState());
  if (Object.entries(payload).length === 0) {
    return Promise.resolve();
  }
  const newRuleBuilder = Object.entries(payload).reduce(
    (builder, [key, value]) => builder[key](value),
    rule.toBuilder()
  );
  const newRule = newRuleBuilder.build();
  const newHighlightingRules = highlightingRules.map((currentRule) => currentRule === rule ? newRule : currentRule);
  return dispatch(updateHighlightingRules(newHighlightingRules));
};
export const addHighlightingRule = (rule) => async (dispatch, getState) => {
  const activeViewState = selectActiveViewState(getState());
  const { formatting = FormattingSettings.empty() } = activeViewState;
  return dispatch(updateHighlightingRules([...formatting.highlighting, rule]));
};
export const addHighlightingRules = (rules) => async (dispatch, getState) => {
  const activeViewState = selectActiveViewState(getState());
  const { formatting = FormattingSettings.empty() } = activeViewState;
  return dispatch(updateHighlightingRules([...formatting.highlighting, ...rules]));
};
export const createHighlightingRule = (field, value) => async (dispatch) => {
  const newRule = HighlightingRule.builder().field(field).value(value).color(randomColor()).build();
  return dispatch(addHighlightingRule(newRule));
};
export const createHighlightingRules = (rules) => async (dispatch) => {
  const newRules = rules.map(
    ({ field, value, color, condition }) => HighlightingRule.builder().field(field).value(value).condition(condition || "equal").color(color || randomColor()).build()
  );
  return dispatch(addHighlightingRules(newRules));
};
export const removeHighlightingRule = (rule) => async (dispatch, getState) => {
  const highlightingRules = selectHighlightingRules(getState());
  const newHighlightingRules = highlightingRules.filter((r) => r !== rule);
  return dispatch(updateHighlightingRules(newHighlightingRules));
};
